export const reais = (v) =>
  `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Valor mínimo (piso) de um preço com o desconto máximo aplicado. O sorteio usa
// a parte inteira da porcentagem, então o preço sorteado nunca fica abaixo dele.
export const piso = (preco, pct) => Math.round(Number(preco || 0) * (100 - Number(pct || 0))) / 100;

// Porcentagem que leva o preço até o mínimo digitado em reais (2 casas).
export const pctDoMinimo = (preco, minimo) => {
  const p = Number(preco || 0);
  const m = Number(minimo);
  if (!(p > 0) || !Number.isFinite(m)) return null;
  return Math.round((1 - m / p) * 10000) / 100;
};

export const textoParaNumero = (texto) => {
  const limpo = String(texto ?? "").replace(/[^\d,.-]/g, "").replace(/\.(?=\d{3}(\D|$))/g, "").replace(",", ".");
  const n = parseFloat(limpo);
  return Number.isFinite(n) ? n : null;
};

export const numeroParaTexto = (n) => (n == null ? "" : Number(n).toFixed(2).replace(".", ","));

// Fotos de upload são servidas atrás de /api (mesma regra do resto do painel).
export function urlDaFoto(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  return url.startsWith("/") ? `/api${url}` : `/api/${url}`;
}

export const slugCategoria = (nome) =>
  String(nome || "sem-categoria").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const MODULOS = [
  { id: "Cardapio", rotulo: "Cardápio digital", dica: "entrega e retirada pelo link da loja" },
  { id: "Delivery", rotulo: "Delivery (atendente)", dica: "pedido anotado por telefone ou balcão de delivery" },
  { id: "Balcao", rotulo: "Balcão", dica: "venda no caixa" },
  { id: "Totem", rotulo: "Totem", dica: "autoatendimento na loja" },
  { id: "Mesas", rotulo: "Mesas", dica: "pedido lançado pelo garçom" },
  { id: "MesaQR", rotulo: "Mesa QR Code", dica: "cliente pede pelo celular na mesa" },
  { id: "Comandas", rotulo: "Comandas", dica: "conta em nome do cliente, sem mesa" },
  // Pedido anotado pela CLEO na conversa. Desmarcado (o padrão), a oferta é exclusiva
  // do cardápio digital: a CLEO vende no preço normal e explica isso se o cliente perguntar.
  { id: "ChatBot", rotulo: "WhatsApp", dica: "pedido anotado pela CLEO na conversa" },
];

export const DADOS = [
  { id: "telefone", rotulo: "Nome e telefone", dica: "o mínimo pra existir cadastro — sempre exigido", fixo: true },
  { id: "cpf", rotulo: "CPF", dica: "amarra a pessoa e dificulta conta duplicada" },
  { id: "data_nascimento", rotulo: "Data de nascimento", dica: "abre campanha de aniversário depois" },
  { id: "email", rotulo: "E-mail", dica: "canal sem custo por mensagem" },
];
